import { useEffect } from "react";

const APP_STORE =
  "https://apps.apple.com/am/app/halper-ai-business-manager/id6745568939";
const PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.halper.ai";
const WEBSITE_HOME = "https://app.halper.ai/profile";

export default function AppRedirect() {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || "";
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isAndroid = /android/i.test(ua);

    if (isIOS) {
      window.location.replace(APP_STORE);
    } else if (isAndroid) {
      window.location.replace(PLAY_STORE);
    } else {
      window.location.replace(WEBSITE_HOME);
    }
  }, []);

  // Shown briefly before redirect
  return <p style={{ textAlign: "center", marginTop: 40 }}>Opening Halper…</p>;
}